export enum OrderOrigins {
    BASKET = 1,
    TICKET = 2
}